// Angular
import { Injectable } from '@angular/core';
// RxJS
import { Subject } from 'rxjs';

import {HttpClient}from '@angular/common/http';

@Injectable()
export class MenuConfigService {
	// Public properties
	onConfigUpdated$: Subject<any>;
	// Private properties
	private menuConfig: any;


	/**
	 * Service Constructor
	 */
	constructor(private http:HttpClient) {
		// register on config changed event and set default config
		this.onConfigUpdated$ = new Subject();
	}

	/**
	 * Returns the menuConfig
	 */
	getMenus() {
		return this.menuConfig;
	}

	/**
	 * Load config
	 *
	 * @param config: any
	 */
	loadConfigs(config: any) {
		this.menuConfig = config;

		//  ;
		// this.http.get<any>(this.baseUrl+'GetMenu').subscribe(data=>{
	
		// 	// ;
		// 	config.aside.items=data;
		// 	this.menuConfig = config;
		// 	var datas=data;
		// 	this.onConfigUpdated$.next(this.menuConfig);
		// })

		// ;
		this.onConfigUpdated$.next(this.menuConfig);
	}
}
